import { FC } from 'react';
import { Modal } from '../Modal';
import { ShopContent } from '../../../types/cms_shared_types';
import { Button } from '../../Common/Button';
import { render } from 'storyblok-rich-text-react-renderer';

interface ResetProcessConfirmationModalProps {
  showModal: boolean;
  setShowModal: (value: boolean) => void;
  cmsShopContent: ShopContent;
  resetProcess: () => void;
  addonsInCart: boolean;
}

export const ResetProcessConfirmationModal: FC<ResetProcessConfirmationModalProps> = ({
  showModal,
  setShowModal,
  cmsShopContent,
  resetProcess,
  addonsInCart,
}) => {
  return (
    <Modal
      showModal={showModal}
      small
      setShowModal={setShowModal}
      header={<div>{cmsShopContent.shoppingCart.resetProcessConfirmationTitle}</div>}
      outsideClickCloses
      content={
        <>
          {addonsInCart
            ? render(cmsShopContent.shoppingCart.resetProcessConfirmationAddonsDescription)
            : render(cmsShopContent.shoppingCart.resetProcessConfirmationDescription)}
        </>
      }
      actions={
        <div className="flex flex-row justify-center w-full">
          <Button
            text={cmsShopContent.productChoiceStep.removeProductButton}
            onClick={resetProcess}
            textColor="text-sami-red"
          />
        </div>
      }
    />
  );
};
